/**
 * @generated SignedSource<<39ced84d74ebf3a0a9a51d52e95ca9dc>>
 * @relayHash ab4fa595e0ee739585584e55b9a41f91
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID a66742ff95bbea34e9bd95288b44f4b4b4da37c3170403c687b03cb3d102a737

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null | undefined;
  customInput?: JiraIssueSearchCustomInput | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
};
export type JiraIssueSearchChildIssuesInput = {
  filterByProjectKeys?: ReadonlyArray<string> | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  namespace?: string | null | undefined;
  parentIssueKey: string;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null | undefined;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  context?: JiraSoftwareIssueSearchCustomInputContext | null | undefined;
  jiraEntityId: string;
};
export type issueFetchAndAppendQuery$variables = {
  cloudId: string;
  fieldIdsOrAliases: ReadonlyArray<string>;
  fieldSetIds: ReadonlyArray<string>;
  isDensityFull: boolean;
  isInlineEditingEnabled: boolean;
  issueKey: string;
  issueSearchInput: JiraIssueSearchInput;
  shouldQueryFieldsByIdOrAlias: boolean;
  shouldQueryMatchesIssueSearch: boolean;
};
export type issueFetchAndAppendQuery$data = {
  readonly jira: {
    readonly issueByKey: {
      readonly $updatableFragmentSpreads: FragmentRefs<"highlightIssueRow_update_isHighlightedIssueRow">;
      readonly __id: string;
      readonly fieldSetsById: {
        readonly __id: string;
        readonly " $fragmentSpreads": FragmentRefs<"issueRow_nativeIssueTable_IssueRowWithFragments_fieldSets">;
      };
      readonly fieldsByIdOrAlias?: ReadonlyArray<{
        readonly __typename: string;
        readonly fieldId: string;
        readonly fieldOption?: {
          readonly optionId: string;
        } | null | undefined;
        readonly number?: number | null | undefined;
        readonly priority?: {
          readonly priorityId: string;
        } | null | undefined;
        readonly sprints?: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly sprintId: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly status?: {
          readonly name: string | null | undefined;
          readonly statusId: string;
        };
        readonly user?: {
          readonly accountId: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly issueId: string;
      readonly key: string;
      readonly matchesIssueSearch?: boolean | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type issueFetchAndAppendQuery = {
  response: issueFetchAndAppendQuery$data;
  variables: issueFetchAndAppendQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": isJscInlineEditRefactorEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": isMultiGroupPickerCellEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": isJscInlineEditFlagFixEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": isRenderJiraWatchesFieldNINEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": includeSingleSelectColorField_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider: {
    readonly get: () => boolean;
  };
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider: {
    readonly get: () => boolean;
  };
});

import isRenderJiraWatchesFieldNINEnabled_provider from '@atlassian/jira-relay-provider/src/is-render-jirawatchesfield-nin.relayprovider';
import isJscInlineEditRefactorEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-field-refactor.relayprovider';
import isJscInlineEditFlagFixEnabled_provider from '@atlassian/jira-relay-provider/src/jsc-inline-editing-flag-fix.relayprovider';
import isMultiGroupPickerCellEnabled_provider from '@atlassian/jira-relay-provider/src/nin-multi-group-picker-cell.relayprovider';
import includeSingleSelectColorField_provider from '@atlassian/jira-relay-provider/src/thor-colorful-single-select-milestone2-experiment.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldIdsOrAliases"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fieldSetIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDensityFull"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isInlineEditingEnabled"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueKey"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQueryFieldsByIdOrAlias"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldQueryMatchesIssueSearch"
},
v9 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "issueKey"
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "key"
},
v11 = {
  "kind": "ScalarField",
  "name": "issueId"
},
v12 = [
  {
    "kind": "Variable",
    "name": "fieldSetIds",
    "variableName": "fieldSetIds"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 500
  }
],
v13 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v14 = [
  {
    "kind": "Variable",
    "name": "idsOrAliases",
    "variableName": "fieldIdsOrAliases"
  }
],
v15 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v16 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v17 = {
  "kind": "ScalarField",
  "name": "statusId"
},
v18 = {
  "kind": "ScalarField",
  "name": "name"
},
v19 = {
  "kind": "ScalarField",
  "name": "priorityId"
},
v20 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v21 = {
  "kind": "ScalarField",
  "name": "optionId"
},
v22 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v23 = {
  "kind": "ScalarField",
  "name": "sprintId"
},
v24 = {
  "kind": "ScalarField",
  "name": "number"
},
v25 = [
  (v24/*: any*/)
],
v26 = {
  "kind": "InlineFragment",
  "selections": (v25/*: any*/),
  "type": "JiraNumberField"
},
v27 = {
  "condition": "shouldQueryMatchesIssueSearch",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "issueSearchInput",
          "variableName": "issueSearchInput"
        }
      ],
      "kind": "ScalarField",
      "name": "matchesIssueSearch"
    }
  ]
},
v28 = {
  "kind": "ScalarField",
  "name": "type"
},
v29 = {
  "kind": "ScalarField",
  "name": "id"
},
v30 = {
  "kind": "ScalarField",
  "name": "value"
},
v31 = [
  (v30/*: any*/),
  (v29/*: any*/),
  {
    "kind": "ScalarField",
    "name": "isDisabled"
  }
],
v32 = {
  "condition": "isInlineEditingEnabled",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "lazyIsEditableInIssueView"
        }
      ]
    }
  ]
},
v33 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v34 = {
  "alias": "value",
  "kind": "ScalarField",
  "name": "id"
},
v35 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "name"
},
v36 = {
  "kind": "ScalarField",
  "name": "dateTime"
},
v37 = {
  "kind": "ScalarField",
  "name": "text"
},
v38 = {
  "kind": "InlineFragment",
  "selections": [
    (v37/*: any*/),
    (v18/*: any*/),
    (v32/*: any*/)
  ],
  "type": "JiraSingleLineTextField"
},
v39 = {
  "kind": "ScalarField",
  "name": "totalCount"
},
v40 = {
  "concreteType": "JiraColor",
  "kind": "LinkedField",
  "name": "color",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "colorKey"
    },
    (v29/*: any*/)
  ]
},
v41 = [
  (v40/*: any*/)
],
v42 = {
  "kind": "ScalarField",
  "name": "picture"
},
v43 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v44 = [
  (v18/*: any*/),
  (v29/*: any*/)
],
v45 = {
  "concreteType": "JiraFieldConfig",
  "kind": "LinkedField",
  "name": "fieldConfig",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isRequired"
    }
  ]
},
v46 = {
  "kind": "ScalarField",
  "name": "statusCategoryId"
},
v47 = {
  "concreteType": "JiraStatusCategory",
  "kind": "LinkedField",
  "name": "statusCategory",
  "plural": false,
  "selections": [
    (v46/*: any*/),
    (v29/*: any*/)
  ]
},
v48 = {
  "concreteType": "JiraSingleLineTextField",
  "kind": "LinkedField",
  "name": "summaryField",
  "plural": false,
  "selections": [
    (v37/*: any*/),
    (v29/*: any*/)
  ]
},
v49 = {
  "concreteType": "JiraColorField",
  "kind": "LinkedField",
  "name": "issueColorField",
  "plural": false,
  "selections": [
    (v40/*: any*/),
    (v29/*: any*/)
  ]
},
v50 = {
  "concreteType": "JiraAvatar",
  "kind": "LinkedField",
  "name": "avatar",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "xsmall"
    }
  ]
},
v51 = {
  "concreteType": "JiraIssueTypeField",
  "kind": "LinkedField",
  "name": "issueTypeField",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraIssueType",
      "kind": "LinkedField",
      "name": "issueType",
      "plural": false,
      "selections": [
        (v50/*: any*/),
        (v18/*: any*/),
        (v29/*: any*/)
      ]
    },
    (v29/*: any*/)
  ]
},
v52 = {
  "kind": "ScalarField",
  "name": "webUrl"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Fragment",
    "name": "issueFetchAndAppendQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v9/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "highlightIssueRow_update_isHighlightedIssueRow"
              },
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "kind": "RequiredField",
                "field": {
                  "args": (v12/*: any*/),
                  "concreteType": "JiraIssueFieldSetConnection",
                  "kind": "LinkedField",
                  "name": "fieldSetsById",
                  "plural": false,
                  "selections": [
                    {
                      "args": [
                        {
                          "kind": "Variable",
                          "name": "isDensityFull",
                          "variableName": "isDensityFull"
                        },
                        {
                          "kind": "Variable",
                          "name": "isInlineEditingEnabled",
                          "variableName": "isInlineEditingEnabled"
                        }
                      ],
                      "kind": "FragmentSpread",
                      "name": "issueRow_nativeIssueTable_IssueRowWithFragments_fieldSets"
                    },
                    (v13/*: any*/)
                  ]
                },
                "action": "THROW",
                "path": "jira.issueByKey.fieldSetsById"
              },
              {
                "condition": "shouldQueryFieldsByIdOrAlias",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": (v14/*: any*/),
                    "kind": "LinkedField",
                    "name": "fieldsByIdOrAlias",
                    "plural": true,
                    "selections": [
                      (v15/*: any*/),
                      (v16/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                              (v17/*: any*/),
                              (v18/*: any*/)
                            ]
                          }
                        ],
                        "type": "JiraStatusField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraPriority",
                            "kind": "LinkedField",
                            "name": "priority",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/)
                            ]
                          }
                        ],
                        "type": "JiraPriorityField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v20/*: any*/)
                            ]
                          }
                        ],
                        "type": "JiraSingleSelectUserPickerField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "fieldOption",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/)
                            ]
                          }
                        ],
                        "type": "JiraSingleSelectField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "args": (v22/*: any*/),
                            "concreteType": "JiraSprintConnection",
                            "kind": "LinkedField",
                            "name": "sprints",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraSprintEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraSprint",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v23/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "sprints(first:1)"
                          }
                        ],
                        "type": "JiraSprintField"
                      },
                      (v26/*: any*/)
                    ]
                  }
                ]
              },
              (v27/*: any*/),
              (v13/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v7/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/),
      (v8/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider"
      },
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "issueFetchAndAppendQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v9/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueByKey",
            "plural": false,
            "selections": [
              (v15/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "args": (v12/*: any*/),
                "concreteType": "JiraIssueFieldSetConnection",
                "kind": "LinkedField",
                "name": "fieldSetsById",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueFieldSetEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssueFieldSet",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v28/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "fieldSetId"
                          },
                          {
                            "concreteType": "JiraIssueFieldConnection",
                            "kind": "LinkedField",
                            "name": "fields",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraIssueFieldEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      (v16/*: any*/),
                                      (v28/*: any*/),
                                      {
                                        "kind": "TypeDiscriminator",
                                        "abstractKey": "__isJiraIssueField"
                                      },
                                      (v29/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraAffectedServiceConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedAffectedServicesConnection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraAffectedServiceEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraAffectedService",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "serviceId"
                                                      },
                                                      (v18/*: any*/),
                                                      (v29/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "JiraAffectedServicesField"
                                      },
                                      {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v18/*: any*/),
                                              {
                                                "concreteType": "JiraCascadingOption",
                                                "kind": "LinkedField",
                                                "name": "cascadingOption",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "parentOptionValue",
                                                    "plural": false,
                                                    "selections": (v31/*: any*/)
                                                  },
                                                  {
                                                    "concreteType": "JiraOption",
                                                    "kind": "LinkedField",
                                                    "name": "childOptionValue",
                                                    "plural": false,
                                                    "selections": (v31/*: any*/)
                                                  }
                                                ]
                                              },
                                              (v32/*: any*/)
                                            ],
                                            "type": "JiraCascadingSelectField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v18/*: any*/),
                                              {
                                                "args": (v33/*: any*/),
                                                "concreteType": "JiraComponentConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedComponentsConnection",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraComponentEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraComponent",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v34/*: any*/),
                                                          (v35/*: any*/),
                                                          (v29/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "storageKey": "selectedComponentsConnection(first:1000)"
                                              },
                                              (v32/*: any*/)
                                            ],
                                            "type": "JiraComponentsField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v36/*: any*/),
                                              (v18/*: any*/),
                                              (v32/*: any*/)
                                            ],
                                            "type": "JiraDateTimePickerField"
                                          },
                                          (v38/*: any*/),
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraCommentSummary",
                                                "kind": "LinkedField",
                                                "name": "commentSummary",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "canAddComment"
                                                  },
                                                  (v39/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraCommentSummaryField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v18/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "uri"
                                              },
                                              (v32/*: any*/)
                                            ],
                                            "type": "JiraUrlField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v18/*: any*/),
                                              {
                                                "concreteType": "JiraOptionConnection",
                                                "kind": "LinkedField",
                                                "name": "fieldOptions",
                                                "plural": false,
                                                "selections": [
                                                  (v39/*: any*/)
                                                ]
                                              },
                                              {
                                                "concreteType": "JiraOption",
                                                "kind": "LinkedField",
                                                "name": "fieldOption",
                                                "plural": false,
                                                "selections": [
                                                  (v30/*: any*/),
                                                  {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": (v41/*: any*/)
                                                  },
                                                  {
                                                    "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": (v41/*: any*/)
                                                  },
                                                  (v29/*: any*/),
                                                  (v21/*: any*/)
                                                ]
                                              },
                                              (v32/*: any*/)
                                            ],
                                            "type": "JiraSingleSelectField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v18/*: any*/),
                                              {
                                                "concreteType": "JiraOptionConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedOptions",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraOptionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraOption",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v29/*: any*/),
                                                          (v30/*: any*/),
                                                          (v21/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              (v32/*: any*/)
                                            ],
                                            "type": "JiraMultipleSelectField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v18/*: any*/),
                                              {
                                                "concreteType": "JiraOptionConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedOptions",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraOptionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraOption",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v29/*: any*/),
                                                          (v30/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              (v32/*: any*/)
                                            ],
                                            "type": "JiraCheckboxesField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v18/*: any*/),
                                              {
                                                "concreteType": "JiraUserConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedUsersConnection",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraUserEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v15/*: any*/),
                                                          (v20/*: any*/),
                                                          (v18/*: any*/),
                                                          (v42/*: any*/),
                                                          (v29/*: any*/),
                                                          (v43/*: any*/),
                                                          {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "email"
                                                              }
                                                            ],
                                                            "type": "AtlassianAccountUser"
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              (v32/*: any*/)
                                            ],
                                            "type": "JiraMultipleSelectUserPickerField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v18/*: any*/),
                                              {
                                                "concreteType": "JiraTeamView",
                                                "kind": "LinkedField",
                                                "name": "selectedTeam",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "jiraSuppliedId"
                                                  },
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "jiraSuppliedName"
                                                  }
                                                ]
                                              },
                                              (v32/*: any*/)
                                            ],
                                            "type": "JiraTeamViewField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "issue",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraTimeTrackingField",
                                                    "kind": "LinkedField",
                                                    "name": "timeTrackingField",
                                                    "plural": false,
                                                    "selections": [
                                                      (v29/*: any*/),
                                                      (v32/*: any*/),
                                                      {
                                                        "concreteType": "JiraEstimate",
                                                        "kind": "LinkedField",
                                                        "name": "originalEstimate",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "timeInSeconds"
                                                          }
                                                        ]
                                                      },
                                                      {
                                                        "concreteType": "JiraTimeTrackingSettings",
                                                        "kind": "LinkedField",
                                                        "name": "timeTrackingSettings",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "workingHoursPerDay"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "workingDaysPerWeek"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "defaultFormat"
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "defaultUnit"
                                                          }
                                                        ]
                                                      },
                                                      (v16/*: any*/),
                                                      (v18/*: any*/),
                                                      (v28/*: any*/)
                                                    ]
                                                  },
                                                  (v29/*: any*/)
                                                ]
                                              }
                                            ],
                                            "type": "JiraOriginalTimeEstimateField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v18/*: any*/),
                                              {
                                                "concreteType": "JiraOption",
                                                "kind": "LinkedField",
                                                "name": "selectedOption",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": "label",
                                                    "kind": "ScalarField",
                                                    "name": "value"
                                                  },
                                                  (v29/*: any*/),
                                                  (v34/*: any*/)
                                                ]
                                              },
                                              (v32/*: any*/)
                                            ],
                                            "type": "JiraRadioSelectField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v18/*: any*/),
                                              {
                                                "args": (v33/*: any*/),
                                                "concreteType": "JiraVersionConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedVersionsConnection",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraVersionEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraVersion",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v29/*: any*/),
                                                          (v18/*: any*/),
                                                          (v34/*: any*/),
                                                          (v35/*: any*/),
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "versionId"
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ],
                                                "storageKey": "selectedVersionsConnection(first:1000)"
                                              },
                                              (v32/*: any*/)
                                            ],
                                            "type": "JiraMultipleVersionPickerField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v18/*: any*/),
                                              {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "issue",
                                                "plural": false,
                                                "selections": [
                                                  (v29/*: any*/)
                                                ]
                                              },
                                              {
                                                "args": (v33/*: any*/),
                                                "concreteType": "JiraGoalConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedGoals",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraGoalEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraGoal",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v29/*: any*/),
                                                          (v10/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v13/*: any*/)
                                                ],
                                                "storageKey": "selectedGoals(first:1000)"
                                              },
                                              (v32/*: any*/),
                                              (v13/*: any*/)
                                            ],
                                            "type": "JiraGoalsField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v18/*: any*/),
                                              {
                                                "args": (v33/*: any*/),
                                                "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
                                                "kind": "LinkedField",
                                                "name": "confluenceRemoteIssueLinks",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraConfluenceRemoteIssueLink",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v29/*: any*/),
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "href"
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v39/*: any*/)
                                                ],
                                                "storageKey": "confluenceRemoteIssueLinks(first:1000)"
                                              },
                                              (v32/*: any*/)
                                            ],
                                            "type": "JiraConfluenceRemoteIssueLinksField"
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraCmdbObjectConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedCmdbObjectsConnection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraCmdbObjectEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraCmdbObject",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "objectId"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "label"
                                                      },
                                                      {
                                                        "concreteType": "JiraCmdbAvatar",
                                                        "kind": "LinkedField",
                                                        "name": "avatar",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "concreteType": "JiraCmdbMediaClientConfig",
                                                            "kind": "LinkedField",
                                                            "name": "mediaClientConfig",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "clientId"
                                                              },
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "fileId"
                                                              },
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "mediaBaseUrl"
                                                              },
                                                              {
                                                                "kind": "ScalarField",
                                                                "name": "mediaJwtToken"
                                                              }
                                                            ]
                                                          },
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "url48"
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              {
                                                "concreteType": "QueryError",
                                                "kind": "LinkedField",
                                                "name": "errors",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "message"
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "JiraCMDBField"
                                      },
                                      {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": false,
                                        "selections": [
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "alias": "componentsOld",
                                                "concreteType": "JiraComponentConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedComponentsConnection",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraComponentEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraComponent",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": (v44/*: any*/)
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ],
                                            "type": "JiraComponentsField"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v37/*: any*/)
                                            ],
                                            "type": "JiraSingleLineTextField"
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "date"
                                          },
                                          (v18/*: any*/),
                                          (v45/*: any*/),
                                          (v32/*: any*/)
                                        ],
                                        "type": "JiraDatePickerField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v36/*: any*/)
                                        ],
                                        "type": "JiraDateTimePickerField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraEpic",
                                            "kind": "LinkedField",
                                            "name": "epic",
                                            "plural": false,
                                            "selections": [
                                              (v10/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "summary"
                                              },
                                              {
                                                "kind": "ScalarField",
                                                "name": "color"
                                              },
                                              (v29/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraEpicLinkField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "renderedFieldHtml"
                                          }
                                        ],
                                        "type": "JiraFallbackField"
                                      },
                                      (v38/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraStatusCategory",
                                            "kind": "LinkedField",
                                            "name": "statusCategory",
                                            "plural": false,
                                            "selections": [
                                              (v18/*: any*/),
                                              (v46/*: any*/),
                                              (v29/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraStatusCategoryField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraStatus",
                                            "kind": "LinkedField",
                                            "name": "status",
                                            "plural": false,
                                            "selections": [
                                              (v18/*: any*/),
                                              (v17/*: any*/),
                                              (v47/*: any*/),
                                              (v29/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraStatusField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "args": (v33/*: any*/),
                                            "concreteType": "JiraLabelConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedLabelsConnection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraLabelEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraLabel",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v18/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              },
                                              (v39/*: any*/)
                                            ],
                                            "storageKey": "selectedLabelsConnection(first:1000)"
                                          },
                                          (v18/*: any*/),
                                          (v32/*: any*/)
                                        ],
                                        "type": "JiraLabelsField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraAvatar",
                                                "kind": "LinkedField",
                                                "name": "avatar",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "small"
                                                  }
                                                ]
                                              },
                                              (v18/*: any*/),
                                              (v29/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraIssueTypeField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraIssue",
                                            "kind": "LinkedField",
                                            "name": "parentIssue",
                                            "plural": false,
                                            "selections": [
                                              (v10/*: any*/),
                                              (v48/*: any*/),
                                              (v29/*: any*/)
                                            ]
                                          },
                                          {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "parentIssue",
                                                "plural": false,
                                                "selections": [
                                                  (v10/*: any*/),
                                                  (v49/*: any*/),
                                                  (v51/*: any*/),
                                                  (v48/*: any*/),
                                                  (v29/*: any*/)
                                                ]
                                              }
                                            ]
                                          },
                                          {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                              {
                                                "concreteType": "JiraIssue",
                                                "kind": "LinkedField",
                                                "name": "parentIssue",
                                                "plural": false,
                                                "selections": [
                                                  (v10/*: any*/),
                                                  (v49/*: any*/),
                                                  (v51/*: any*/),
                                                  (v48/*: any*/),
                                                  (v29/*: any*/),
                                                  (v11/*: any*/),
                                                  (v52/*: any*/),
                                                  {
                                                    "args": [
                                                      {
                                                        "kind": "Literal",
                                                        "name": "ids",
                                                        "value": [
                                                          "summary",
                                                          "issuetype",
                                                          "status"
                                                        ]
                                                      }
                                                    ],
                                                    "concreteType": "JiraIssueFieldConnection",
                                                    "kind": "LinkedField",
                                                    "name": "fieldsById",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraIssueFieldEdge",
                                                        "kind": "LinkedField",
                                                        "name": "edges",
                                                        "plural": true,
                                                        "selections": [
                                                          {
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                              (v15/*: any*/),
                                                              (v29/*: any*/),
                                                              {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                  (v16/*: any*/),
                                                                  (v37/*: any*/)
                                                                ],
                                                                "type": "JiraSingleLineTextField"
                                                              },
                                                              {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                  (v16/*: any*/),
                                                                  {
                                                                    "concreteType": "JiraIssueType",
                                                                    "kind": "LinkedField",
                                                                    "name": "issueType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      {
                                                                        "kind": "ScalarField",
                                                                        "name": "issueTypeId"
                                                                      },
                                                                      (v18/*: any*/),
                                                                      (v50/*: any*/),
                                                                      {
                                                                        "concreteType": "JiraIssueTypeHierarchyLevel",
                                                                        "kind": "LinkedField",
                                                                        "name": "hierarchy",
                                                                        "plural": false,
                                                                        "selections": [
                                                                          {
                                                                            "kind": "ScalarField",
                                                                            "name": "level"
                                                                          }
                                                                        ]
                                                                      },
                                                                      (v29/*: any*/)
                                                                    ]
                                                                  }
                                                                ],
                                                                "type": "JiraIssueTypeField"
                                                              },
                                                              {
                                                                "kind": "InlineFragment",
                                                                "selections": [
                                                                  (v16/*: any*/),
                                                                  {
                                                                    "concreteType": "JiraStatus",
                                                                    "kind": "LinkedField",
                                                                    "name": "status",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v47/*: any*/),
                                                                      (v29/*: any*/)
                                                                    ]
                                                                  }
                                                                ],
                                                                "type": "JiraStatusField"
                                                              }
                                                            ]
                                                          }
                                                        ]
                                                      }
                                                    ],
                                                    "storageKey": "fieldsById(ids:[\"summary\",\"issuetype\",\"status\"])"
                                                  }
                                                ]
                                              },
                                              (v18/*: any*/),
                                              (v32/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraParentIssueField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraPriority",
                                            "kind": "LinkedField",
                                            "name": "priority",
                                            "plural": false,
                                            "selections": [
                                              (v18/*: any*/),
                                              {
                                                "kind": "ScalarField",
                                                "name": "iconUrl"
                                              },
                                              (v29/*: any*/)
                                            ]
                                          },
                                          (v18/*: any*/),
                                          (v32/*: any*/)
                                        ],
                                        "type": "JiraPriorityField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                              (v18/*: any*/),
                                              (v10/*: any*/),
                                              {
                                                "concreteType": "JiraAvatar",
                                                "kind": "LinkedField",
                                                "name": "avatar",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "large"
                                                  }
                                                ]
                                              },
                                              (v29/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraProjectField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraResolution",
                                            "kind": "LinkedField",
                                            "name": "resolution",
                                            "plural": false,
                                            "selections": (v44/*: any*/)
                                          }
                                        ],
                                        "type": "JiraResolutionField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraSprintConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedSprintsConnection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraSprintEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraSprint",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      (v29/*: any*/),
                                                      (v23/*: any*/),
                                                      (v18/*: any*/),
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "state"
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "endDate"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          },
                                          (v18/*: any*/),
                                          (v32/*: any*/)
                                        ],
                                        "type": "JiraSprintField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": [
                                              (v15/*: any*/),
                                              (v20/*: any*/),
                                              (v42/*: any*/),
                                              (v18/*: any*/),
                                              (v29/*: any*/),
                                              (v43/*: any*/)
                                            ]
                                          },
                                          (v18/*: any*/),
                                          (v45/*: any*/),
                                          (v32/*: any*/)
                                        ],
                                        "type": "JiraSingleSelectUserPickerField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          (v18/*: any*/),
                                          {
                                            "args": (v33/*: any*/),
                                            "concreteType": "JiraVersionConnection",
                                            "kind": "LinkedField",
                                            "name": "selectedVersionsConnection",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraVersionEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraVersion",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": (v44/*: any*/)
                                                  }
                                                ]
                                              }
                                            ],
                                            "storageKey": "selectedVersionsConnection(first:1000)"
                                          }
                                        ],
                                        "type": "JiraMultipleVersionPickerField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraRichText",
                                            "kind": "LinkedField",
                                            "name": "richText",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "concreteType": "JiraADF",
                                                "kind": "LinkedField",
                                                "name": "adfValue",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "condition": "isDensityFull",
                                                    "kind": "Condition",
                                                    "passingValue": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraAdfToConvertedPlainText",
                                                        "kind": "LinkedField",
                                                        "name": "convertedPlainText",
                                                        "plural": false,
                                                        "selections": [
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "plainText"
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  {
                                                    "condition": "isDensityFull",
                                                    "kind": "Condition",
                                                    "passingValue": true,
                                                    "selections": [
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "json"
                                                      }
                                                    ]
                                                  }
                                                ]
                                              }
                                            ]
                                          }
                                        ],
                                        "type": "JiraRichTextField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "concreteType": "JiraServiceManagementRequestType",
                                            "kind": "LinkedField",
                                            "name": "requestType",
                                            "plural": false,
                                            "selections": [
                                              (v18/*: any*/),
                                              (v50/*: any*/),
                                              (v29/*: any*/)
                                            ]
                                          }
                                        ],
                                        "type": "JiraServiceManagementRequestTypeField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "args": (v22/*: any*/),
                                            "concreteType": "JiraIssueLinkConnection",
                                            "kind": "LinkedField",
                                            "name": "issueLinkConnection",
                                            "plural": false,
                                            "selections": [
                                              (v39/*: any*/),
                                              {
                                                "concreteType": "JiraIssueLinkEdge",
                                                "kind": "LinkedField",
                                                "name": "edges",
                                                "plural": true,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraIssueLink",
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraIssue",
                                                        "kind": "LinkedField",
                                                        "name": "issue",
                                                        "plural": false,
                                                        "selections": [
                                                          (v52/*: any*/),
                                                          (v10/*: any*/),
                                                          {
                                                            "args": [
                                                              {
                                                                "kind": "Literal",
                                                                "name": "ids",
                                                                "value": [
                                                                  "statusCategory"
                                                                ]
                                                              }
                                                            ],
                                                            "concreteType": "JiraIssueFieldConnection",
                                                            "kind": "LinkedField",
                                                            "name": "fieldsById",
                                                            "plural": false,
                                                            "selections": [
                                                              {
                                                                "concreteType": "JiraIssueFieldEdge",
                                                                "kind": "LinkedField",
                                                                "name": "edges",
                                                                "plural": true,
                                                                "selections": [
                                                                  {
                                                                    "kind": "LinkedField",
                                                                    "name": "node",
                                                                    "plural": false,
                                                                    "selections": [
                                                                      (v15/*: any*/),
                                                                      {
                                                                        "kind": "InlineFragment",
                                                                        "selections": [
                                                                          (v47/*: any*/)
                                                                        ],
                                                                        "type": "JiraStatusCategoryField"
                                                                      },
                                                                      (v29/*: any*/)
                                                                    ]
                                                                  }
                                                                ]
                                                              }
                                                            ],
                                                            "storageKey": "fieldsById(ids:[\"statusCategory\"])"
                                                          },
                                                          (v29/*: any*/)
                                                        ]
                                                      },
                                                      {
                                                        "kind": "ScalarField",
                                                        "name": "relationName"
                                                      },
                                                      (v29/*: any*/)
                                                    ]
                                                  }
                                                ]
                                              }
                                            ],
                                            "storageKey": "issueLinkConnection(first:1)"
                                          }
                                        ],
                                        "type": "JiraIssueLinkField"
                                      },
                                      {
                                        "kind": "InlineFragment",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "isStoryPointField"
                                          },
                                          (v24/*: any*/),
                                          (v18/*: any*/),
                                          {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": false,
                                            "selections": (v25/*: any*/)
                                          },
                                          {
                                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                              (v24/*: any*/),
                                              (v18/*: any*/),
                                              (v32/*: any*/)
                                            ]
                                          },
                                          (v32/*: any*/)
                                        ],
                                        "type": "JiraNumberField"
                                      },
                                      {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              (v18/*: any*/),
                                              {
                                                "concreteType": "JiraGroupConnection",
                                                "kind": "LinkedField",
                                                "name": "selectedGroupsConnection",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "JiraGroupEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                      {
                                                        "concreteType": "JiraGroup",
                                                        "kind": "LinkedField",
                                                        "name": "node",
                                                        "plural": false,
                                                        "selections": [
                                                          (v29/*: any*/),
                                                          (v18/*: any*/),
                                                          {
                                                            "kind": "ScalarField",
                                                            "name": "groupId"
                                                          }
                                                        ]
                                                      }
                                                    ]
                                                  }
                                                ]
                                              },
                                              (v32/*: any*/)
                                            ],
                                            "type": "JiraMultipleGroupPickerField"
                                          }
                                        ]
                                      },
                                      {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraFlag",
                                                "kind": "LinkedField",
                                                "name": "flag",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "isFlagged"
                                                  }
                                                ]
                                              }
                                            ],
                                            "type": "JiraFlagField"
                                          }
                                        ]
                                      },
                                      {
                                        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider",
                                        "kind": "Condition",
                                        "passingValue": true,
                                        "selections": [
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "concreteType": "JiraWatch",
                                                "kind": "LinkedField",
                                                "name": "watch",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "kind": "ScalarField",
                                                    "name": "count"
                                                  }
                                                ]
                                              }
                                            ],
                                            "type": "JiraWatchesField"
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v13/*: any*/)
                ]
              },
              (v29/*: any*/),
              {
                "condition": "shouldQueryFieldsByIdOrAlias",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "args": (v14/*: any*/),
                    "kind": "LinkedField",
                    "name": "fieldsByIdOrAlias",
                    "plural": true,
                    "selections": [
                      (v15/*: any*/),
                      (v16/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraStatus",
                            "kind": "LinkedField",
                            "name": "status",
                            "plural": false,
                            "selections": [
                              (v17/*: any*/),
                              (v18/*: any*/),
                              (v29/*: any*/)
                            ]
                          }
                        ],
                        "type": "JiraStatusField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraPriority",
                            "kind": "LinkedField",
                            "name": "priority",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              (v29/*: any*/)
                            ]
                          }
                        ],
                        "type": "JiraPriorityField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              (v20/*: any*/),
                              (v29/*: any*/)
                            ]
                          }
                        ],
                        "type": "JiraSingleSelectUserPickerField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "concreteType": "JiraOption",
                            "kind": "LinkedField",
                            "name": "fieldOption",
                            "plural": false,
                            "selections": [
                              (v21/*: any*/),
                              (v29/*: any*/)
                            ]
                          }
                        ],
                        "type": "JiraSingleSelectField"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "args": (v22/*: any*/),
                            "concreteType": "JiraSprintConnection",
                            "kind": "LinkedField",
                            "name": "sprints",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "JiraSprintEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "JiraSprint",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v23/*: any*/),
                                      (v29/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "sprints(first:1)"
                          }
                        ],
                        "type": "JiraSprintField"
                      },
                      (v26/*: any*/),
                      (v29/*: any*/)
                    ]
                  }
                ]
              },
              (v27/*: any*/),
              (v13/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "a66742ff95bbea34e9bd95288b44f4b4b4da37c3170403c687b03cb3d102a737",
    "metadata": {},
    "name": "issueFetchAndAppendQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingfieldrefactorrelayprovider": isJscInlineEditRefactorEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcninmultigrouppickercellrelayprovider": isMultiGroupPickerCellEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcjscinlineeditingflagfixrelayprovider": isJscInlineEditFlagFixEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcisrenderjirawatchesfieldninrelayprovider": isRenderJiraWatchesFieldNINEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcthorcolorfulsingleselectmilestone2experimentrelayprovider": includeSingleSelectColorField_provider
    }
  }
};
})();

(node as any).hash = "7b5ac1e2e0250a1cde0ecb3978c426c1";

export default node;
